{
    "invitations": {
        "title": "User Invitations",
        "dialogs": {
            "delete": {
                "title": "Are you sure?",
                "content": "Are you sure you want to delete this user invitation? You can't undo this action"
            }
        }
    }
}